<h1 mat-dialog-title>
  {{title}}
</h1>

<div mat-dialog-content>
  <div [innerHTML]="message"></div>
</div>

<div mat-dialog-actions>
  <button type="button" mat-raised-button color="primary" (click)="onConfirm()">Confirm</button>
  <button type="button" mat-button (click)="onCancel()">Cancel</button>
</div>

